import { MenuItem } from "@mui/material";
import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";

type AlignTextFieldProps = {
  name: string;
  value: any;
  onChange: (value: any) => void;
};

const AlignTextField = (props: AlignTextFieldProps) => {
  return (
    <EditorVisualTextField
      select
      label="Align"
      size="small"
      fullWidth
      name={props.name}
      value={props.value}
      onChange={props.onChange}
    >
      <MenuItem value="left">Left</MenuItem>
      <MenuItem value="center">Center</MenuItem>
      <MenuItem value="right">Right</MenuItem>
    </EditorVisualTextField>
  );
};

export default AlignTextField;
